// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as JsBindings from "../../../../../library/JS/JsBindings.bs.js";
import * as ScoreSliderPinV2 from "./ScoreSliderPinV2.bs.js";
import * as ScoreSliderTrackV2 from "./ScoreSliderTrackV2.bs.js";
import * as ScoreSliderValueBoxV2 from "./ScoreSliderValueBoxV2.bs.js";
import * as PartnerScoreV2CssHelper from "../../../domain/helper/PartnerScoreV2CssHelper.bs.js";

function ScoreSliderV2(Props) {
  var current_score = Props.current_score;
  var max_score = Props.max_score;
  var track_thresholds = Props.track_thresholds;
  var action_details = Props.action_details;
  var match = React.useState(function () {
        return 0;
      });
  var set_value_box_height = match[1];
  var match$1 = React.useState(function () {
        return 0;
      });
  var set_slider_container_height = match$1[1];
  var match$2 = React.useState(function () {
        return 0;
      });
  var set_slider_track_height = match$2[1];
  var update_value_box_height = function (val) {
    return Curry._1(set_value_box_height, (function (param) {
                  return val;
                }));
  };
  var update_slider_track_height = function (val) {
    return Curry._1(set_slider_track_height, (function (param) {
                  return val;
                }));
  };
  React.useEffect((function () {
          var element = document.getElementById("slider-container-v2");
          Curry._1(set_slider_container_height, (function (param) {
                  return JsBindings.offsetHeight(element);
                }));
          
        }), []);
  var val = PartnerScoreV2CssHelper.getSliderPinHeight(match[0], match$1[0], match$2[0], current_score, max_score, action_details.action_threshold);
  var tmp = val === "0" ? null : React.createElement(ScoreSliderPinV2.make, {
          current_score: current_score,
          val: val,
          max_score: max_score
        });
  return React.createElement("div", {
              className: "slider-container-v2",
              id: "slider-container-v2"
            }, React.createElement(ScoreSliderValueBoxV2.make, {
                  current_score: current_score,
                  max_score: max_score,
                  isSuspended: action_details.active_suspension,
                  update_value_box_height: update_value_box_height
                }), tmp, React.createElement(ScoreSliderTrackV2.make, {
                  track_thresholds: track_thresholds,
                  current_score: current_score,
                  max_score: max_score,
                  update_slider_track_height: update_slider_track_height,
                  action_details: action_details
                }));
}

var make = ScoreSliderV2;

export {
  make ,
  
}
/* react Not a pure module */
